<template>
  <div class="page-wrapper">
    <div class="content">
      <homeDesktop />
    </div>

    <PubVue v-if="showPub" />
    <footerDesktop />
    <footerMobile v-if="isMobile" />
  </div>
</template>


<script setup>
import { ref, computed, onMounted, getCurrentInstance } from 'vue'
import { useWindowSize } from '@vueuse/core'
import homeDesktop from './components/homeDesktop.vue'
import PubVue from './components/pubVue.vue'

import footerDesktop from './components/footerDesktop.vue'
import footerMobile from './components/footerMobile.vue'

const { width } = useWindowSize()
const isMobile = computed(() => width.value <= 800)

const instance = getCurrentInstance()
const idSite = instance?.appContext.config.globalProperties.$idSite ?? 43

const showPub = ref(false)

onMounted(async () => {
  try {
    const res = await fetch(`https://admin.asso-refuge.fr/getPages/${idSite}`)
    const pages = await res.json()
    showPub.value = Array.isArray(pages) && pages.some(p => p.name === 'pub')
  } catch {
    showPub.value = false
  }
})
</script>